import { Template } from "chq";

const isSelectedTemplate = (
  selectedTemplates: Template[],
  template?: Template
): boolean => !!selectedTemplates.find(t => t.id === template?.id);

export default isSelectedTemplate;
